<button data-testid="auto-app-email-campaign-outlook-button-button-1" class="reset-button c-btn px-5 py-3" (click)="connectoOutlook()">
  <div class="align-items-center d-flex">
    <div class="d-flex justify-content-center align-items-center">
      <img src="assets/ourtlook.png" alt="Outlook" class="mr-2" style="aspect-ratio: 1;" width="22" />
    </div>
    <span>Continue with outlook</span>
  </div>
</button>